import { mutateStaff } from "./staffAccess";
import { recordActivity } from "./auditActivity";
const operation = (ref, kind, data, options) => {
  const parts=ref?.path?.split("/")||[];
  if(parts.length!==2)throw Error("A staff record is required.");
  return {collection:parts[0],id:parts[1],kind,...(data===undefined?{}:{data}),...(options?.merge===true?{merge:true}:{})};
};
async function save(operations) {
  try{return await mutateStaff(operations);}
  catch(error){void recordActivity("operation.failed",{collection:operations[0]?.collection||"",id:operations[0]?.id||""},error.code||"unknown");throw error;}
}
export const setDoc=(ref,data,options)=>save([operation(ref,"set",data,options)]);
export const updateDoc=(ref,data)=>save([operation(ref,"update",data)]);
export const deleteDoc=ref=>save([operation(ref,"delete")]);
export function writeBatch() {
  const operations=[];let committed=false;
  const add=(...args)=>{if(committed)throw Error("This batch is already committed.");const next=operation(...args),index=operations.findIndex(prior=>prior.collection===next.collection&&prior.id===next.id);
    if(index<0)operations.push(next);
    else{const prior=operations[index];operations[index]=next.kind==="delete"||next.kind==="set"&&!next.merge?next:{...next,kind:prior.kind==="set"?"set":next.kind,merge:prior.kind==="set"?prior.merge:next.merge,data:{...prior.data,...next.data}};}
    return batch;};
  const batch={set:(ref,data,options)=>add(ref,"set",data,options),update:(ref,data)=>add(ref,"update",data),delete:ref=>add(ref,"delete"),commit:async()=>{if(committed)throw Error("This batch is already committed.");committed=true;if(operations.length)await save(operations);}};
  return batch;
}
